import { LayoutGrid, Plus } from 'lucide-react'
import type { Dashboard } from '../types'
import { plural } from '../format'

// "My dashboards" with no board open, where the chat is unavailable (MP-OS-193): the user's
// boards to open, or an empty state. Nothing here points at the chat.
export function DashboardIndex({
  dashboards,
  onOpen,
  onNew,
}: {
  dashboards: Dashboard[]
  onOpen: (id: string) => void
  onNew: () => void
}) {
  return (
    <div className="dash-empty dash-index" aria-label="Your dashboards">
      <h1 className="section-h1">My dashboards</h1>
      {dashboards.length === 0 ? (
        <p>You have no dashboards yet. Create one and add <strong>Text cards</strong> or start from a template.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: 8 }}>
          {dashboards.map((d) => (
            <li key={d.id}>
              <button type="button" onClick={() => onOpen(d.id)} aria-label={`Open ${d.name}`}>
                <LayoutGrid size={15} aria-hidden /> {d.name} · {d.cards.length} {plural(d.cards.length, 'card')}
              </button>
            </li>
          ))}
        </ul>
      )}
      <button type="button" onClick={onNew}>
        <Plus size={15} aria-hidden /> New dashboard
      </button>
    </div>
  )
}
